import './UnitsUnloadedModal.scss';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Error from '../../../../common/Error/Error';
import GoodsIn from '../../../../api/controllers/GoodsIn/GoodsIn';
import LoadingSpinner from '../../../../common/LoadingSpinner/LoadingSpinner';
import Button from '../../../../common/Button/Button';

// General UnitsUnloadedModal Component
const UnitsUnloadedModal = ({
  category,
  assignment,
  movementId,
  job,
  setModalOpen,
  refreshMovement,
  currentTotal,
  movementType,
}) => {
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [total, setTotal] = useState(null);

  const expectedNumber = assignment?.quantity;
  const expectedType = job?.packageType?.name;

  useEffect(() => {
    setTotal(currentTotal == 0 ? expectedNumber : currentTotal);
  }, []);

  const updatePackageTotal = () => {
    setLoading(true);
    GoodsIn.updatePackageCount(
      category,
      movementId,
      job?.id,
      total == null ? expectedNumber : total,
    )
      .then(() => {
        setLoading(false);
        refreshMovement();
        setModalOpen(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  return (
    <div className="set_units_unloaded_container">
      {loading && <LoadingSpinner />}
      {error && (
        <Error
          errorMessages={error}
          type={'error'}
          errorTitle={
            Array.isArray(error)
              ? `${error.length} error${error.length > 1 ? 's' : ''} occurred: `
              : ''
          }
        />
      )}
      <div className="message">
        Please enter the number of distinct units (i.e. pallets/crates/etc.) that are being unloaded
        for <b>{job?.jobReference}</b> below.
      </div>
      <div className="num_of_packages_container">
        <input
          data-testid={'package_number_input'}
          className="number_of_packages"
          type="number"
          placeholder={`Expecting ${expectedNumber || 'N/A'} ${expectedType || 'Package'}(s)`}
          value={total == null ? expectedNumber : total}
          onChange={e => setTotal(e.target.value)}
        />
        <div className="block_label">Items</div>
      </div>
      <Button
        className="start_button"
        onClick={() => updatePackageTotal()}
        label={`Update ${movementType == 'collections' ? 'Collection' : 'Import'}`}
      />
    </div>
  );
};

UnitsUnloadedModal.propTypes = {
  category: PropTypes.string,
  movementType: PropTypes.string,
  assignment: PropTypes.object,
  job: PropTypes.object,
  setModalOpen: PropTypes.func,
  refreshMovement: PropTypes.func,
  currentTotal: PropTypes.number,
  movementId: PropTypes.number,
};

export default UnitsUnloadedModal;
